import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Vehicle } from 'src/app/shared/models/vehicle';
import { VehiculeStatus } from 'src/app/shared/enums/vehicule-status-enum';
import { Mission } from 'src/app/shared/models/mission/mission';
import { VehiculeModalDetailRouteComponent } from '../modal/vehicule-modal-detail-route/vehicule-modal-detail-route.component';
import { LogService } from 'src/app/core/services/log/log.service';
import { Route } from 'src/app/shared/models/route';
import { CenterDepartment } from 'src/app/shared/models/center-department';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { update } from 'lodash';

@Component({
	selector: 'app-detail-vehicule',
	templateUrl: './detail-vehicule.component.html',
	styleUrls: ['./detail-vehicule.component.scss']
})
export class DetailVehiculeComponent implements OnInit {
	vehicule: Vehicle;
	confirmDeleteModalRef: BsModalRef;

	centerDepartments: CenterDepartment[];
	selectedCenterDepartment: CenterDepartment = null;

	isDeletable: boolean;

	MAX_NAME_CHAR = 50;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");
	// NUMBER_PATTERN = new RegExp('^[0-9]+$');

	detailForm: FormGroup = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		model: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		rented: new FormControl(''),
		gps: new FormControl(''),
		status: new FormControl(''),
		travelledDistance: new FormControl('', [
			Validators.required
			// Validators.pattern(this.NUMBER_PATTERN)
		]),
		mileageCost: new FormControl('', [
			Validators.required
			// Validators.pattern(this.NUMBER_PATTERN)
		]),
		centerDepartment: new FormControl('')
	});

	isFormReadOnly: boolean = true;

	vehiculeStatus = VehiculeStatus;

	detailMission: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	currentPage: number;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.isDeletable = this.facade.dataStorageService.isPlanificatrice();
		let vehiculeId = +this.route.snapshot.paramMap.get('id');
		this.getCenterDepartments();
		this.facade.vehiculeService.getVehiculeById(vehiculeId).subscribe({
			next: (vehicule: Vehicle) => {
				this.vehicule = vehicule;
				this.vehicule.routes.forEach(
					(route) =>
						(route.missions = route.missions.sort(
							(missionA, missionB) =>
								missionA.plannedStart - missionB.plannedStart
						))
				);
				this.resetForm();
			},
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
			}
		});
	}

	getCenterDepartments() {
		this.facade.centerDepartmentService
			.getAllCenterDepartmentsForUserCenter()
			.subscribe({
				next: (centerDepartments) => {
					this.centerDepartments = centerDepartments;
				},
				error: (err: ErrorResponse) => {}
			});
	}

	goBack(): void {
		this.router.navigate(['/gestion/vehicules/list']);
	}

	delete(vehicule: Vehicle): void {
		if (this.isDeletable) {
			this.facade.vehiculeService.deleteVehicule(vehicule).subscribe((_) => {
				this.confirmDeleteModalRef.hide();
				this.goBack();
			});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>) {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	openModalDetailMission(route: Route): void {
		const initialState = {
			vehicule: this.vehicule,
			route
		};
		this.detailMission = this.modalService.show(
			VehiculeModalDetailRouteComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	resetForm() {
		this.detailForm.reset();
		this.detailForm.setValue({
			name: this.vehicule.name,
			model: this.vehicule.model,
			rented: this.vehicule.rented,
			gps: this.vehicule.gps,
			status: this.vehicule.status,
			travelledDistance:
				this.vehicule.travelledDistance !== null
					? this.vehicule.travelledDistance
					: 0,
			mileageCost:
				this.vehicule.mileageCost !== null ? this.vehicule.mileageCost : 0,
			centerDepartment: this.vehicule.centerDepartment
				? this.vehicule.centerDepartment.name
				: null
		});
	}

	typeaheadCenterDepartmentOnSelect(event: TypeaheadMatch): void {
		this.selectedCenterDepartment = event.item as CenterDepartment;
	}

	centerDepartmentsKeyUp(e: any) {
		if (
			this.selectedCenterDepartment &&
			this.selectedCenterDepartment.name +
				' ' +
				this.selectedCenterDepartment.name !=
				e.value
		) {
			this.selectedCenterDepartment = null;
		}
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked = false;
		this.resetForm();
	}

	onSubmit() {
		if (this.detailForm.valid) {
			this.isValidateButtonClicked = true;
			let updatedVehicule: Vehicle = JSON.parse(JSON.stringify(this.vehicule));
			updatedVehicule.name = this.name.value;
			updatedVehicule.model = this.model.value;
			updatedVehicule.rented = this.detailForm.get('rented').value;
			updatedVehicule.gps = this.detailForm.get('gps').value;
			updatedVehicule.status = this.detailForm.get('status').value;
			updatedVehicule.travelledDistance = this.travelledDistance.value;
			updatedVehicule.mileageCost = this.mileageCost.value;
			updatedVehicule.centerDepartment = this.selectedCenterDepartment;
			this.facade.vehiculeService.updateVehicule(updatedVehicule).subscribe({
				next: (succ) => {
					this.vehicule = updatedVehicule;
					this.stopEditForm(true);
				},
				error: (err) => {
					this.isValidateButtonClicked = false;
					this.facade.toastService.createWarningToast(
						"Le véhicule n'a pas pu être mis à jour"
					);
				}
			});
		}
	}

	get name() {
		return this.detailForm.get('name');
	}
	get model() {
		return this.detailForm.get('model');
	}
	get travelledDistance() {
		return this.detailForm.get('travelledDistance');
	}
	get mileageCost() {
		return this.detailForm.get('mileageCost');
	}
	get centerDepartment() {
		return this.detailForm.get('centerDepartment');
	}
}
